"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _hooks = require("../../../../utils/hooks");

var _Navigation = _interopRequireDefault(require("../../../Navigation"));

var _FooterNavigation = _interopRequireDefault(require("../../FooterNavigation"));

var _Social = _interopRequireDefault(require("../../../Social"));

var _PrimaryFooter = require("./PrimaryFooter.style");

var PrimaryFooter = function PrimaryFooter(_ref) {
  var columns = _ref.columns,
      copyrightText = _ref.copyrightText,
      secondaryLinks = _ref.secondaryLinks,
      social = _ref.social;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      breakpoints = _ref2.breakpoints;

  var windowWidth = (0, _hooks.useWindowWidth)();
  var isLargeNav = windowWidth >= parseInt(breakpoints.medium, 10);
  var hasMounted = (0, _hooks.useHasMounted)();
  return /*#__PURE__*/_react.default.createElement(_PrimaryFooter.Wrapper, {
    role: "contentinfo"
  }, hasMounted && /*#__PURE__*/_react.default.createElement(_FooterNavigation.default, {
    columns: columns,
    isLargeNav: isLargeNav
  }), social && /*#__PURE__*/_react.default.createElement(_PrimaryFooter.FooterSocial, null, /*#__PURE__*/_react.default.createElement(_PrimaryFooter.FooterSocialWrapper, null, /*#__PURE__*/_react.default.createElement(_Social.default, social))), /*#__PURE__*/_react.default.createElement(_PrimaryFooter.FooterUtility, null, /*#__PURE__*/_react.default.createElement(_PrimaryFooter.UtilityContainer, null, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
    links: secondaryLinks,
    type: "utilityFooter",
    size: "small"
  }), /*#__PURE__*/_react.default.createElement(_PrimaryFooter.FooterCopyright, {
    size: "small",
    color: "greymid",
    py: ['small', null, null, null, 'none']
  }, "\xA9 ", copyrightText))));
};

PrimaryFooter.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.oneOf(['nav', 'html']),
    component: _propTypes.default.shape({})
  })),
  copyrightText: _propTypes.default.string,
  secondaryLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  social: _propTypes.default.shape({
    media: _propTypes.default.arrayOf(_propTypes.default.shape({
      name: _propTypes.default.string,
      url: _propTypes.default.string
    })),
    text: _propTypes.default.string
  })
};
PrimaryFooter.defaultProps = {
  columns: [],
  copyrightText: 'Copyright Ascential Events (Europe) Limited',
  secondaryLinks: [],
  social: null
};
var _default = PrimaryFooter;
exports.default = _default;